import {
    EActivityCategories,
    EBoaterTestOptions,
    ECalendarView,
    EPassengerOptions,
    EProtectionPlanOptions,
    ETipAmount,
} from '@/domain/Activities.domain';
import { getSelectOptionsFromEnum } from '@/service/utils/getSelectOptionsFromEnum';

export const calendarViewOptions = [ECalendarView.ACTIVITIES, ECalendarView.TIME];

export const categoryImages = {
    [EActivityCategories.PONTOON]: 'bg-pontoon-boat dark:bg-pontoon-boat-dark',
    [EActivityCategories.BOAT]: 'bg-boat-tours dark:bg-boat-tours-dark',
    [EActivityCategories.DOLPHIN]: 'bg-dolphin-cruises dark:bg-dolphin-cruises-dark',
    [EActivityCategories.PARASAILING]: 'bg-parasailing dark:bg-parasailing-dark',
    [EActivityCategories.SUNSET]: 'bg-sunset-cruises dark:bg-sunset-cruises-dark',
    [EActivityCategories.TOURIST]: 'bg-tourist-attractions dark:bg-tourist-attractions-dark',
    [EActivityCategories.KAYAK]: 'bg-kayak-attractions dark:bg-kayak-attractions-dark',
    [EActivityCategories.BOARD]: 'bg-board-attractions dark:bg-board-attractions-dark',
    [EActivityCategories.SAIL]: 'bg-sail-attractions dark:bg-sail-attractions-dark',
    [EActivityCategories.JET]: 'bg-jet-attractions dark:bg-jet-attractions-dark',
    [EActivityCategories.FISH]: 'bg-fish-attractions dark:bg-fish-attractions-dark',
    [EActivityCategories.WAVE]: 'bg-wave-attractions dark:bg-wave-attractions-dark',
};

export const tripSelections = [
    {
        name: 'passenger_count',
        label: 'HOW MANY TOTAL PASSENGERS ON THIS PONTOON?',
        info: 'Everyone including infants count. If we cannot meet your party needs, please give us a call',
        placeholder: 'Choose an Option',
        selectOptions: getSelectOptionsFromEnum(EPassengerOptions),
    },
    {
        name: 'protection_plan',
        label: 'DAMAGE PROTECTION PLAN',
        placeholder: 'Choose an Option',
        selectOptions: getSelectOptionsFromEnum(EProtectionPlanOptions),
        description: `You have the option to purchase a non-refundable Damage
        Protection Plan that will cover up to $1000 of damage to the
        rented vessel, motor, and equipment, only. This plan does not
        cover any other vessels or any other property. This plan does
        not cover any personal injury or Liability coverage`,
    },
    {
        name: 'boater_test',
        label: "NEED BOATER'S TEST?",
        placeholder: 'Choose an Option',
        selectOptions: getSelectOptionsFromEnum(EBoaterTestOptions),
        description: `If you are born ON or AFTER January 1st, 1988, Florida law requires you to have a boating license if you want to drive a jet ski or a pontoon boat. Get your license now by clicking the link below >>`,
        link: 'https://tmbt.info/3lkuzUY',
    },
];

export const tipAmounts = [
    ETipAmount.TEN_PERCENT,
    ETipAmount.FIFTEEN_PERCENT,
    ETipAmount.EIGHTEEN_PERCENT,
    ETipAmount.NONE,
    ETipAmount.CUSTOM,
];

export const cancellationPolicy = {
    paragraph_1: `A $500 per boat cash deposit or credit card charge is required and will be refunded once the boat is returned without damage.`,
    paragraph_2: `($1000 Deposit required May 1st for Billy Bowlegs, no exceptions) Customers may cancel at least 24 hours prior to their arrival date and time to receive a full refund minus a $5 service fee. No refunds or changes can be `,
    paragraph_3: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero, minima.`,
};
